<section class="sbnb-onboarding">
  <sbnb-signup-header></sbnb-signup-header>

  <article class="main">
    <header>
      <h2 class="nomargin">Here is our onboarding menu.</h2>
    </header>
    <section class="content">
      <p class="menu-subtitle">
        <span *ngIf="wizard.signupUser.property_count > 2">
          Everybody runs their business in a different way. So we have created different onboarding options adapted to
          your unique style.
        </span>
      </p>

      <section class="menu-plans">
        <article class="sbnb-plan" [class.recommended]="wizard.signupUser.property_count < 5">
          <img fxHide.lt-md class="onboarding-img" src="/assets/images/signup/onboarding-jumpstart.svg" />
          <header><h1>Jumpstart</h1></header>
          <p class="strong">Start with our proven configuration.</p>
          <footer>
            <button mat-flat-button class="fw" [disabled]="loading" (click)="onboardingSelected('jumpstart')">
              <span class="night">Get started</span>
            </button>
          </footer>
          <ul class="features">
            <li>Start with our recommended configuration and tested templates.</li>
            <li>Still used as is by 70% of our users.</li>
            <li>Start automating booking confirmations and inquiries now.</li>
            <li>Manual activation needed for check-in and check-out instructions.</li>
          </ul>
        </article>
      </section>
    </section>
  </article>
</section>
